"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var moment_1 = __importDefault(require("moment"));
var CONTENT_COLLAPSE_LENGTH = 200;
var BlogComment = function (_a) {
    var comment = _a.comment;
    var _b = react_1.default.useState(true), isCollapsed = _b[0], setIsCollapsed = _b[1];
    return (react_1.default.createElement("div", { className: "blogComment-CommentCard" },
        react_1.default.createElement("div", { className: "blogComment-CommentCard_Header" },
            react_1.default.createElement("div", { className: "blogComment-CommentCard_NickName" },
                "\u6295\u7A3F\u8005: ",
                comment.nickName),
            react_1.default.createElement("div", { className: "blogComment-CommentCard_CreatedAt" }, (0, moment_1.default)(comment.createdAt).format('LLL'))),
        react_1.default.createElement("p", { className: "blogComment-CommentCard_Content" }, comment.content.length > CONTENT_COLLAPSE_LENGTH && isCollapsed
            ? "".concat(comment.content.slice(0, CONTENT_COLLAPSE_LENGTH), "...")
            : comment.content),
        comment.content.length > CONTENT_COLLAPSE_LENGTH &&
            react_1.default.createElement("div", { className: "blogComment-CommentCard_CollapseTextWrapper" },
                react_1.default.createElement("span", { onClick: function () { return setIsCollapsed(!isCollapsed); }, className: "blogComment-CommentCard_CollapseText" }, isCollapsed ? 'もっと見る' : '閉じる'))));
};
exports.default = BlogComment;
